import React, { useRef, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Navbar from "../../common/navbar/mainnavbar";
import { Button, Dropdown } from "react-bootstrap";
import { RiDiscountPercentFill } from "react-icons/ri";
import { FiRefreshCw } from "react-icons/fi";
import Footer from "../../common/footer";
import { useLocation } from "react-router-dom";
import googlePlayImg from "../../assets/img/googelPlay.png";
import logoImg from "../../assets/img/logo/logorumneo.svg";

const faqs = [
  {
    question: "DOSAGE AND USAGE",
    answer:
      "The purpose of animal feed supplements is to improve the nutritional value of animal diets by the use of specialty items. They supply vital elements such as vitamins, minerals, and amino acids, which may be deficient in ordinary food.",
  },
  {
    question: "PRODUCT DESCRIPTION",
    answer:
      "The All-in-One Mineral Superstar for Goats, Cattle, Dogs, and Cats is Minromix! Pets and livestock both benefit from a well-balanced diet that includes all the necessary vitamins and minerals.Minromix is a veterinarian-recommended mineral mixture for cattle and other animals, Minromix is designed to meet the dietary requirements of different species. For Your Healthy Herd of Cattle: Essential Mineral Blend for Cattle: Minromix offers a wide range of minerals that have been carefully selected to ensure the best possible health for cattle. This includes magnesium for healthy muscle function, phosphorus for appropriate development, and calcium for strong bones and milk production. Encourages Peak Milk Production: Minromix will help dairy farmers ensure that their cows are producing healthy amounts of milk. The yield of your herd can be increased by making sure it is getting enough minerals. Encourages Growth and Development: Minromix supplies the vital minerals required for appropriate growth and development at every stage of life, from robust adult cattle to healthy calves. Enhances General Health of Cattle: Cattle that are deficient in certain minerals may have a range of health issues. By offering a comprehensive and well-balanced mineral mixture, Minromix helps avoid these problems and eventually contributes to a robust and healthy herd. Beyond Cattle: A Mineral Solution Across Species Although Minromix works well as a mineral mixture for cattle, it can also be used for other kinds of animals. Goats: Give your goats this adaptable mineral formula to support good reproductive, strong bones, and general well-being. Canines and Felines: Give your pets extra minerals in their diet to help them thrive, which will promote overall health, energy, and a glossy coat. Why Pick Minromix? Comprehensive and Specific: Minromix provides a mineral combination that is both complete and targeted to meet the unique requirements of goats, dogs, cats, and cattle. Simple to Handle: Minromix's easy-to-use structure makes it simple to incorporate into your pets' daily diet. Encourages General Animal Health: Minromix helps your animals' well-being in many ways, from strong bones and robust reproduction to enhanced immunity and vivid hair. Make an investment in Minromix, the One-Stop Mineral Powerhouse! You can make sure your animals flourish and have the greatest life possible by giving them the vital minerals they require with Minromix!",
  },
];

const Addtocart = () => {
  const location = useLocation();

  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const product = location.state?.product;

  // const cartItem = cart?.find((item) => item.id === product?.id);

  const [selectedWeight, setSelectedWeight] = useState(
    product?.productUnit?.[0]
  );
  const basePrice = product.price;
  const calculatedPrice = parseFloat(selectedWeight) * basePrice;

  // const setWeight = (size) => {
  //   setSelectedWeight(size);
  // };
  // const decrease = (id) => {
  //   decrementQuantity();
  // };

  // Handle Add to Cart
  // const handleAddToCart = async (product) => {
  //   if (!isAuthenticated) {
  //     console.log("Redirecting to login...");
  //     setTimeout(() => {
  //       navigate("/login");
  //     }, 100);
  //     toast.warning("Please login to add items!", { autoClose: 3000 });
  //     return;
  //   }
  //   console.log("selectedWeightHandleAddToCart: ", selectedWeight);
  //   addToCart(product, selectedWeight);
  //   console.log("product, selectedWeight: ", product, selectedWeight);

  //   //  const response = await postData("/addtoCart",);
  // };

  const downloadAppRef = useRef(null);

  const scrollToDownloadApp = () => {
    if (downloadAppRef.current) {
      const navbarHeight = 90;
      const top =
        downloadAppRef.current.getBoundingClientRect().top +
        window.pageYOffset -
        navbarHeight;
      window.scrollTo({ top, behavior: "smooth" });
    }
  };

  const handleAddToCart = async (product) => {
    scrollToDownloadApp();
  };

  return (
    <>
      <Navbar />
      <div className="addtocart pt-5">
        {/* <div className="pt-5">
          <Header title="Goat Suppliment" subtitle={product.name} link="/goatproduct"/>
        </div> */}
        <div className="container pt-lg-5">
          <div className="row pt-3 justify-content-center">
            <div key={product.id} className="row">
              <div className="col-lg-6">
                <div className="addtocart-img">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="img-fluid border rounded-4"
                  />
                </div>
              </div>
              <div className="col-lg-1"></div>
              <div className="col-lg-5">
                <div className="addtocart-content">
                  <p className="addtocart-content-title font-20-400">
                    {product.name}
                  </p>
                  <div className="d-flex align-items-center">
                    <span className="fs-3 me-2 colorEC7229">★★★★★</span>
                    <span className="font-14-500 color707070">
                      3.5 (312 Reviews)
                    </span>
                  </div>
                  <p className="mt-2 pb-4 border-bottom font-24-500 font-17-600 d-flex align-items-center">
                    <span> ₹ {calculatedPrice.toFixed(2)} /- </span>
                    <Dropdown className="ms-2">
                      <Dropdown.Toggle
                        className="badge p-2 font-14-300 text-white border-0 shadow"
                        style={{ background: "#E32C2B" }}
                      >
                        <RiDiscountPercentFill className="me-1" />
                        5% Off
                      </Dropdown.Toggle>

                      <Dropdown.Menu className="p-3 mt-2 addtocart-dropdown bg-f3fafc border-0 shadow">
                        <p className="mb-0 font-12-400 text-gray-color">
                          Get 5% discount on susbscribing youtube channel & get
                          extra 5% discount on next order by sharing 2 min video
                          product feedback it is for the benefit of yourself in
                          learning innovative ideas of livestock farming by
                          watching youtube channel and your feedback will help
                          new customers to gain the confidence in using products
                          .Your feedback video will also help you to gain more
                          discounts in future orders. If your feedback video
                          gets 100 likes you will earn one loyality point which
                          will equal to Rupees 25 per point. Your points will be
                          counted and redeemed after 60 days.
                        </p>
                      </Dropdown.Menu>
                    </Dropdown>
                  </p>

                  <p
                    className="mt-4 mb-0"
                    style={{
                      fontSize: "14px",
                      fontWeight: "400",
                      color: "#707070",
                    }}
                  >
                    Select Size
                  </p>

                  <div className="d-flex justify-content-between flex-wrap pb-4 border-bottom">
                    {product?.productUnit?.map((size) => (
                      <button
                        key={size}
                        className="addsize-btn d-flex border rounded-3 mt-3"
                        style={{
                          background:
                            selectedWeight === size ? "#E32C2B" : "#ffffff",
                          color:
                            selectedWeight === size ? "#ffffff" : "#111111",
                        }}
                        onClick={() => setSelectedWeight(size)}
                      >
                        <div
                          className="input-group-text border-0"
                          style={{
                            background: "transparent",
                            fontSize: "14px",
                            fontWeight: "400",
                            color:
                              selectedWeight === size ? "#ffffff" : "#707070",
                          }}
                        >
                          ₹ {size * basePrice.toFixed(2)} /-{" "}
                        </div>
                        <div
                          className="input-group-text border-0 product-kg"
                          style={{
                            color:
                              selectedWeight === size ? "#ffffff" : "#111111",
                            fontSize: "14px",
                            fontWeight: "400",
                          }}
                        >
                          {size}kg
                        </div>
                      </button>
                    ))}
                  </div>

                  <p
                    className="mt-3 mb-2"
                    style={{
                      fontSize: "14px",
                      fontWeight: "400",
                      color: "#707070",
                    }}
                  >
                    Delivery
                  </p>
                  <p
                    style={{
                      fontSize: "16px",
                      fontWeight: "500",
                      color: "#111111",
                    }}
                  >
                    4-5 working days
                  </p>
                  <p
                    style={{
                      color: "#EC7229",
                      fontSize: "12px",
                      fontWeight: "400",
                    }}
                  >
                    <FiRefreshCw /> Refundable for any manufacturing defect
                    within 1 week
                  </p>
                  <div className="d-flex align-items-center gap-3 pt-lg-5 mt-lg-5">
                    <div
                      className="buynow-btn d-flex align-items-center justify-content-center"
                      style={{
                        borderColor: "#EC7229",
                      }}
                    >
                        <Button
                          onClick={scrollToDownloadApp}
                          className="fs-5 border-0 rounded-3 px-4 py-2 w-100"
                          style={{
                            background: "#ffffff",
                            color: "#EC7229",
                          }}
                        >
                          Buy Now
                        </Button>
                      {/* <Button
                        onClick={() => decrementQuantity(product.id)}
                        className="border-0 rounded-3 fs-3"
                        style={{ background: "#ffffff", color: "#EC7229" }}
                      >
                        -
                      </Button>
                      <span className="mx-3 fs-4">
                        {cartItem?.quantity || 0}
                      </span>
                      <Button
                        // onClick={() => incrementQuantity(product.id)}
                        onClick={() => handleAddToCart(product, selectedWeight)}
                        className="fs-3 border-0 rounded-3"
                        style={{ background: "#ffffff", color: "#EC7229" }}
                      >
                        +
                      </Button> */}
                    </div>
                    <div className="addtocart-btn">
                      {/* <NavLink to="/cart"> */}
                      <Button
                        className=" border-0"
                        onClick={() => handleAddToCart(product)}
                        // style={{
                        //   background: "#EC7229",
                        //   width: "100%",
                        //   height: "56px",
                        //   borderRadius: "8px",
                        // }}
                      >
                        Add To Cart
                      </Button>
                      {/* </NavLink> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-6 py-5">
              <div className="addtocart-faq">
                <div className="accordion" id="faqAccordion">
                  {faqs.map((faq, index) => (
                    <div className="accordion-item pb-3" key={index}>
                      <h2 className="accordion-header">
                        <button
                          className={`accordion-button  ${
                            openIndex === index
                              ? "addtocart-colapse color-707070"
                              : "collapsed "
                          }`}
                          type="button"
                          // data-bs-toggle="collapse"
                          // data-bs-target={`#collapse${index}`}
                          onClick={() => toggleFAQ(index)}
                          aria-expanded={openIndex === index}
                          aria-controls={`collapse${index}`}
                          style={{
                            fontSize: "16px",
                            fontWeight: "400",
                            borderRadius: "0px",
                            borderTop: "1px solid #E8E8E8",
                            borderBottom: "1px solid #E8E8E8",
                            height: "58px",
                            color: "#707070",
                          }}
                        >
                          {faq.question}{" "}
                          <span
                            className="icon"
                            style={{
                              marginLeft: "auto",
                              color: "#707070",
                              width: "17px",
                              height: "36px",
                              fontSize: "24px",
                              fontWeight: "400",
                            }}
                          >
                            {openIndex === index ? "âˆ’" : "+"}
                          </span>
                        </button>
                      </h2>
                      <div
                        id={`collapse${index}`}
                        className={`accordion-collapse collapse ${
                          openIndex === index ? "show" : ""
                        }`}
                        data-bs-parent="#faqAccordion"
                      >
                        <div className="accordion-body text-gray-color">
                          {faq.answer}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Download App Section */}
      <div
        ref={downloadAppRef}
        style={{
          background: "linear-gradient(135deg, #EC7229 0%, #E32C2B 100%)",
          borderRadius: "16px",
          margin: "24px auto",
          maxWidth: "960px",
          padding: "0 24px",
        }}
      >
        <div
          className="d-flex align-items-center justify-content-between flex-wrap gap-3"
          style={{ padding: "16px 0" }}
        >
          {/* Left: icon + text */}
          <div className="d-flex align-items-center gap-3">
            <div
              style={{
                width: "48px",
                height: "48px",
                borderRadius: "12px",
                background: "rgba(255,255,255,0.22)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
                overflow: "hidden",
              }}
            >
              <img
                src={logoImg}
                alt="Rumeno"
                style={{ width: "34px", height: "34px", objectFit: "contain" }}
              />
            </div>
            <div>
              <p
                className="mb-0 fw-bold text-white"
                style={{ fontSize: "15px", lineHeight: "1.25", letterSpacing: "0.2px" }}
              >
                Download the Rumeno App
              </p>
              <p
                className="mb-0 text-white"
                style={{ fontSize: "12px", opacity: 0.82 }}
              >
                Buy products &amp; manage your farm — right from your phone
              </p>
            </div>
          </div>

          {/* Right: badge */}
          <a
            href="https://play.google.com/store/apps/details?id=com.rumeno.app"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: "inline-block",
              borderRadius: "10px",
              overflow: "hidden",
              boxShadow: "0 2px 10px rgba(0,0,0,0.25)",
              transition: "transform 0.18s ease, box-shadow 0.18s ease",
              flexShrink: 0,
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-2px)";
              e.currentTarget.style.boxShadow = "0 6px 18px rgba(0,0,0,0.35)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "0 2px 10px rgba(0,0,0,0.25)";
            }}
          >
            <img
              src={googlePlayImg}
              alt="Get it on Google Play"
              style={{ height: "42px", display: "block" }}
            />
          </a>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Addtocart;
